import React from 'react';
import { Button, Card, CardContent } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { LayoutPageGrid } from '../../../ui/LayoutGrid';
import { SeasonsGrid } from './SeasonsGrid';

export const SeasonsPage = () => {
  return (
    <LayoutPageGrid
      title="Сезоны"
      tools={
        <Button
          color="primary"
          variant="contained"
          component={Link}
          to="/battle-pass/seasons/create"
        >
          Создать сезон
        </Button>
      }
    >
      <Card>
        <CardContent>
          <SeasonsGrid />
        </CardContent>
      </Card>
    </LayoutPageGrid>
  );
};
